angular.module('unica_invitation_list.invitation_list_controllers')

.controller('InvitationListComunicateGPApprovedController',
	function(
		$rootScope, $scope, $state, $stateParams, $filter, $timeout,
		$confirm,
		GrandPrixComunicateService
	) {

		$scope.event_id = $stateParams.event_id;

		$rootScope.getServicesUsers();

		$rootScope.getEvent( $stateParams.event_id );


		/**
		 * FUNCTIONS FOR CHECK THE FORM AND SAVE THE DEM CONFIRMATION
		 */

		$scope.checkDemForm = function()
		{
			if ( !$scope.forms.dem_form.$invalid &&
				$rootScope.eventData ) {
				return false;
			}
			return true;
		};

		$scope.saveDem = function()
		{
			$rootScope.showLoader();

			var eventData = angular.copy($rootScope.eventData);

			GrandPrixComunicateService
				.updateGPApproved(eventData)
				.then(function(data) {
					$rootScope.hideLoader();

					if ( data ) {

						$rootScope.eventData = data;

						$scope.showSuccessMsg('Email di approvazione aggiornata con successo!', '');
					}
				});
		};


		/**
		 * FUNCTIONS FOR AUTOCOMPLETE USER FOR PREVIEW
		 */

		$scope.searchText = '';

		$scope.searchServiceUser = function(query)
		{
			return query ? $filter('filter')($rootScope.servicesUsers, {label: query}) : $rootScope.servicesUsers;
		};

		$scope.selectedServiceUser = function(service)
		{
			$scope.previewDemData.user_id = ( service ? service.id : null );
		};





		/**
		 * FUNCTIONS FOR PREVIEW FUNCTIONALITY
		 */

		$scope.previewDemData = {
			user_id: null
		};

		$scope.checkPreviewDemForm = function()
		{
			return !$scope.previewDemData.user_id;
		};

		$scope.previewDem = function()
		{
			GrandPrixComunicateService
				.previewGPApproved( $rootScope.eventData.id, $scope.previewDemData.user_id )
				.then(function(data) {
					$rootScope.hideLoader();

					if ( data ) {
						$scope.showSuccessMsg('Anteprima inviata con successo!', '');
					}
				});
		};

	});